/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ZteRowFragmentDoc } from '../../components/zte/__generated__/ZteTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ZteBatchesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ZteBatchesQuery = { __typename?: 'Query', zteBatches: Array<{ __typename?: 'ZteBatch', id: string, downloadUrl?: string | null, batchName: string, claimedDisplay?: number | null, createdAt: any, customerName?: string | null, fileName: string, organizationName?: string | null, pairedDisplay?: number | null, status: string, totalDisplay?: number | null, unClaimedDisplay?: number | null, validated?: number | null, createdBy?: string | null }> };


export const ZteBatchesDocument = gql`
    query zteBatches {
  zteBatches {
    ...ZteRow
  }
}
    ${ZteRowFragmentDoc}`;

/**
 * __useZteBatchesQuery__
 *
 * To run a query within a React component, call `useZteBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZteBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZteBatchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useZteBatchesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ZteBatchesQuery, ZteBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ZteBatchesQuery, ZteBatchesQueryVariables>(ZteBatchesDocument, options);
      }
export function useZteBatchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ZteBatchesQuery, ZteBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ZteBatchesQuery, ZteBatchesQueryVariables>(ZteBatchesDocument, options);
        }
export type ZteBatchesQueryHookResult = ReturnType<typeof useZteBatchesQuery>;
export type ZteBatchesLazyQueryHookResult = ReturnType<typeof useZteBatchesLazyQuery>;
export type ZteBatchesQueryResult = ApolloReactCommon.QueryResult<ZteBatchesQuery, ZteBatchesQueryVariables>;